<template>
  <q-layout>
    <q-page-container>
  <q-page class="bg-primary window-height window-width row justify-center items-center">
    <div class="column">

      <div class="row">
        <q-card  class="q-pa-lg">
          <q-card-section class="q-py-lg flex flex-center">
            <q-spinner
                color="primary"
                size="3em"
            />
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-page>
      </q-page-container>
        </q-layout>
</template>

<script>

import {fetchEnv} from "@/helpers/form";
import {Notify} from "quasar";

export default {
  name: 'LogoutComponent',
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {
    this.logout();
  },
  methods: {
    logout() {

      fetchEnv('/front/api/v1/logout', {

      })
          .then(
              (response) => {
                this.isSending = false;
                if(response.authenticated === undefined || response.authenticated === true) {
                  let errorBlock = '';
                  for(let key in response.error) {
                    errorBlock += '<p style="color: red">'+response.error[key]+'</p>';
                  }
                  if(errorBlock) {
                    Notify.create(  //'Something went wrong');
                        {
                          message: '<p><em>Something went wrong</em></p>' + errorBlock,
                          html: true,
                          timeout: 5000
                        });
                  } else {
                    Notify.create(
                        {
                          message: response.message,
                          html: true,
                          timeout: 5000
                        });
                  }
                  console.log('login log');
                } else {
                  //Notify.create('Submitted');
                  this.isSent = true;
                  this.$router.push('/login')
                }
              })
          .catch(error => console.log(error));
    },
  },
}
</script>

<style scoped>
.q-card {
  width: 360px;
}
.text-decoration-none {
  text-decoration: none;
}
</style>